<ng-container *ngIf="initialized ">
  <datex-wizard [stepConfigs]="getStepConfigs()" (finish)="finish()" (close)="close()" (commandsTmpRef)="commandsTmpRefChange($event)" [stepsResultFunc]="stepsResultFunc.bind(this)"></datex-wizard>
</ng-container>

